import { forwardRef } from 'react'

import Input from '../Input'

import { UnifreeProps } from './type'

export default forwardRef<HTMLInputElement, UnifreeProps>(function Unifree(
  { heightClass = 'regular', ...props },
  ref
) {
  return <Input {...props} {...{ ref, heightClass }} />
})
